import { Grid } from '@material-ui/core';
import * as React from 'react';

import { Container } from '../../../Layout/components/Container';
import { IAgencyService } from '../../store/models';
import { ServiceItem } from './ServiceItem';

import './index.scss';

interface IProps {
    content: IAgencyService[];
}

export const Services: React.FC<IProps> = ({
    content: services
}) => {
    return (
        <div className="services">
            <Container>
                <div className="services__title">
                    <h1>Our Services</h1>
                </div>
                <div className="services__items">
                    <Grid container>
                        {services.map(service => (
                            <ServiceItem
                                key={service.id}
                                service={service}
                            />
                        ))}
                    </Grid>
                </div>
            </Container>
        </div>
    );
};
